import { styled, Grid } from '../../../../../../base';

// export const StyledGrid = styled(Grid, {isFirstItem: boolean})(({ theme }) => ({
//     padding: '16px',
//     borderBottom: `1px solid ${theme.palette.divider}`,
// }));

export const StyledGrid = styled(Grid)<{ isFirstItem: boolean }>(
    ({ isFirstItem, theme }) => ({
        padding: '16px 0',
        borderTop: isFirstItem
            ? 'inherit'
            : `1px solid ${theme.palette.divider}`,
    })
);

export const ImportanceIndicator = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    justifyContent: 'center',

    '& .dots': {
        display: 'flex',
        gap: '4px',
    },

    '& .dot': {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: theme.palette.grey[300],
        '&.filled': {
            backgroundColor: theme.palette.grey[600],
        },
    },

    '& .label': {
        color: theme.palette.text.secondary,
        fontSize: '12px',
    },
}));

export const SkillRange = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
});
